import React from "react";
import { useTranslation, Trans } from "react-i18next";

// sass
import "../../scss/common.scss";
import "../../scss/component.scss";

const app = process.env.REACT_APP_MODE;

// モーダルに何か渡したい場合はここ追加する
type Props = {
    activeStep: number,
    isOption: boolean
}

const FormStep: React.FC<Props> = ({
    activeStep,
    isOption
}) => {
  const { t, i18n } = useTranslation();

  let stepList: string[] = [];
  const baseSteps = {
    ja: {
      customer: t("お客様br情報入力"),
      option: t("オプションbr情報入力"),
      insurance: t("保険加入のbr選択"),
      payment: t("決済情報のbr入力"),
      confirmation: t("予約br最終確認"),
      complete: t("予約完了")
    },
    other: {
      customer: t("お客様br情報入力"),
      option: t("オプションbr情報入力"),
      payment: t("決済情報のbr入力"),
      confirmation: t("予約br最終確認"),
      complete: t("予約完了")
    }
  };
  
  const isJapanese = i18n.language === 'ja';
  
  if (isOption) {
    stepList = isJapanese
      ? [baseSteps.ja.customer, baseSteps.ja.option, baseSteps.ja.insurance, baseSteps.ja.payment, baseSteps.ja.confirmation, baseSteps.ja.complete]
      : [baseSteps.other.customer, baseSteps.other.option, baseSteps.other.payment, baseSteps.other.confirmation, baseSteps.other.complete];
    
    if (activeStep > 2 && !isJapanese) {
      activeStep--;
    }
  } else {
    stepList = isJapanese
      ? [baseSteps.ja.customer, baseSteps.ja.insurance, baseSteps.ja.payment, baseSteps.ja.confirmation, baseSteps.ja.complete]
      : [baseSteps.other.customer, baseSteps.other.payment, baseSteps.other.confirmation, baseSteps.other.complete];
    
    if (activeStep !== 1 && isJapanese) {
      activeStep--;
    } else if (activeStep !== 1 && !isJapanese) {
      activeStep -= 2
    }
  }
  
  return (
    <>
         <div className="form-step">
            <ul className="form-step-list">
              {stepList.map((step, sIndex) => (
                <>
                  <li className={"form-step-list-item" + (activeStep === (sIndex + 1)? " active":"")}>
                    <span className="form-step-list-item-label">{sIndex + 1}</span>
                    <span dangerouslySetInnerHTML={{ __html: step }}></span>
                  </li>
                </>
              ))}
            </ul>
        </div>
    </>
  );
};

export default FormStep;
